import { ReactNode } from 'react';

import { closeSnackbar, SnackbarProvider } from 'notistack';

interface CustomSnackbarProviderProps {
    children?: ReactNode;
}

export function CustomSnackbarProvider({ children }: CustomSnackbarProviderProps) {
    return (
        <SnackbarProvider
            dense
            maxSnack={5}
            disableWindowBlurListener
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            action={(snackbarId) => <span onClick={() => closeSnackbar(snackbarId)} style={{ position: 'absolute', inset: 0, cursor: 'pointer' }} />}
        >
            {children}
        </SnackbarProvider>
    );
}
